import { PRODUCT_TABLE_TYPES } from '../../../lib/constants';

const tableComponent = PRODUCT_TABLE_TYPES.STANDARD;

const columns = (id) => [
  {
    elements: [
      {
        type: 'ApplyNow',
        props: {
          logoLink: true,
          impressionId: `logo-${id}`,
        },
      },
      {
        type: 'StarRating',
      },
      {
        type: 'ApplyNow',
        props: {
          impressionId: `cta-${id}`,
        },
      },
    ],
  },
  {
    name: 'Monthly fee',
    elements: [
      {
        type: 'EditableQuickFacts',
        props: {
          quickFactName: 'getQuickFactMonthlyFee',
        },
      },
    ],
  },
  {
    name: 'Out-of-Network ATM Fee',
    width: 180,
    elements: [
      {
        type: 'EditableQuickFacts',
        props: {
          quickFactName: 'getQuickFactOutOfNetworkATMFee',
        },
      },
    ],
  },
  {
    name: 'Details',
    elements: [
      {
        type: 'CollapsibleParagraph',
        props: {
          title: 'Why we like it',
          paragraphPath: 'product.additional_data.summary',
        },
      },
    ],
  },
];

export default {
  columns,
  tableComponent,
};
